function sendPageView(pathname) {
  const ga = window.ga;
  const isDev = process.env.NODE_ENV === "development";

  if (isDev) {
    return "No pageview recorded because the app is not in production mode";
  }

  if (!ga) {
    throw Error("Google Analtyics is undefined");
  } else {
    ga("set", "page", pathname);
    ga("send", "pageview");
  }
}

export default sendPageView;



// WEBPACK FOOTER //
// ./src/util/analytics/sendPageView.js